<template>
  <button
    :class="['vc-button-wrapper', 'vc-button--' + type, customClass, block || size === 'auto' ? 'vc-button--block' : null, disabled ? 'vc-button--disabled' : null]"
    :hover-class=" hoverClass || 'vc-button--hover'" :style="wrapperStyled" :disabled="disabled" :open-type="openType"
    @getphonenumber="onGetPhoneNumber" @getuserinfo="onGetUserInfo" @opensetting="onOpenSetting" @tap="onClick">
    <view
      :class="['vc-button', plain ? 'vc-button--plain' : null, border && !isLinearGradient && !disabled ? 'vc-hairline--surround' : null]"
      :style="buttonStyled">
      <vc-loading v-if="loading" type="spinner" color="#fff"></vc-loading>
      <template v-else>
        <slot v-if="icon" name="icon">
          <vc-icon class="vc-button__icon" :name="icon" :size="iconSize" :color="iconColor" />
        </slot>
        <view class="vc-button__text">
          <slot></slot>
        </view>
      </template>
    </view>
  </button>
</template>

<script>
import { addUnit } from '../../common/util';
import '../style'

export default {
  name: 'vc-button',
  props: {
    // 按钮类型
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'primary', 'info', 'success', 'error', 'text', 'custom'].includes(value);
      },
    },
    // 左侧图标图片链接
    icon: null,
    // 左侧图标尺寸
    iconSize: {
      type: [Number, String],
      default: 16
    },
    // 左侧图标颜色
    iconColor: {
      type: String,
      default: '#fff'
    },
    // 按钮颜色，支持传入linear-gradient渐变色
    color: null,
    // 是否为朴素按钮
    plain: {
      type: Boolean,
      default: false,
    },
    // default-默认大小  mini-小尺寸 auto-自定义
    size: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'mini', 'large', 'auto'].includes(value);
      }
    },
    // 是否为块级元素
    block: {
      type: Boolean,
      default: false,
    },
    // 按钮圆角弧度
    radius: {
      type: Number,
      default: 0,
    },
    // 是否为圆形按钮
    round: {
      type: Boolean,
      default: false,
    },
    // 是否显示边框
    border: {
      type: Boolean,
      default: true,
    },
    // 小程序开放能力
    openType: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    // 加载中状态，防重复点击
    loading: {
      type: Boolean,
      default: false
    },
    hoverClass: null,
    // 自定义组件 class
    customClass: null,
    // 自定义组件样式
    customStyle: null
  },
  data() {
    return {
      antiRepeatClick: false
    };
  },
  computed: {
    isLinearGradient() {
      // 是否自定义渐变色
      return this.color && /^linear.+/.test(this.color);
    },
    wrapperStyled() {
      let style = '';
      if (this.type === 'text') {
        if (this.disabled) {
          style += 'background: none;';
        }
      } else {
        // 背景色
        if (this.type === 'custom') {
          let colorStyle = '';
          if (this.color) {
            colorStyle += `background: ${this.color};border-color: ${this.color};color: #fff;`;
          }
          if (this.plain) {
            colorStyle += `color: ${this.color};border-color: ${this.color};`;
          }
          style += colorStyle;
        }

        if (this.plain) {
          style += 'background: none;';
        }

        // 圆角
        if (this.round) {
          style += 'border-radius: 999px;';
        } else {
          style += `border-radius: ${addUnit(this.radius)};`;
        }

        // 按钮尺寸
        if (this.size == 'mini') {
          style += 'height: 72rpx; font-size: 24rpx;';
        } else if (this.size == 'large') {
          style += 'height: 104rpx; font-size: 32rpx;';
        } else if (this.size == 'auto') {
          style += 'height: 100%; font-size: inherit;';
        } else {
          style += 'height: 88rpx; font-size: 32rpx;';
        }
      }
      return style + this.customStyle;
    },
    buttonStyled() {
      let style = '';
      // 圆角
      if (this.round) {
        style += 'border-radius: 999px;';
      } else {
        style += `border-radius: ${addUnit(this.radius * (this.plain ? 1 : 2))};`;
      }
      return style;
    },
    clickable() {
      return !this.disabled && !this.loading && !this.antiRepeatClick;
    }
  },
  methods: {
    onClick(e) {
      if (!this.clickable) return;
      this.antiRepeatClick = true;
      this.$emit('click', e);
      setTimeout(() => {
        this.antiRepeatClick = false;
      }, 1000);
    },
    onGetPhoneNumber(e) {
      this.$emit('getphonenumber', e.detail);
    },
    onOpenSetting(e) {
      this.emit('opensetting', e.detail);
    },
    onGetUserInfo(e) {
      this.$emit('getuserinfo', e.detail);
    }
  }
};
</script>
